import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["classes", "label", "data", "DataTypographyProps", "LabelTypographyProps", "i"];
import React, { Fragment } from 'react';
import { FieldLabel } from './FieldLabel';
import { FieldData } from './FieldData';
export const FieldsNoSpace = _ref => {
  let {
    classes,
    label,
    data,
    DataTypographyProps,
    LabelTypographyProps,
    i
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Fragment, null, label && /*#__PURE__*/React.createElement(FieldLabel, _extends({
    classes: classes,
    label: label
  }, props, LabelTypographyProps, {
    i: i
  })), /*#__PURE__*/React.createElement(FieldData, _extends({
    data: data
  }, DataTypographyProps)));
};